import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let timeoutId;

    const restoreSession = () => {
      try {
        const storedUser = localStorage.getItem('user');
        const storedToken = localStorage.getItem('token');
        const storedRole = localStorage.getItem('role');

        if (storedUser && storedToken) {
          const loginTime = localStorage.getItem('loginTime');
          const currentTime = new Date().getTime();
          const sessionDuration = storedRole === 'platformadmin' ? 30 * 60 * 1000 : 2 * 60 * 60 * 1000;

          if (loginTime && currentTime - loginTime > sessionDuration) {
            logout();
          } else {
            setUser(JSON.parse(storedUser));
            setToken(storedToken);
            setRole(storedRole);

            if (loginTime) {
              const remainingTime = sessionDuration - (currentTime - loginTime);
              if (window.sessionTimeoutId) clearTimeout(window.sessionTimeoutId);
              window.sessionTimeoutId = setTimeout(() => {
                logout();
              }, remainingTime);
            }
          }
        }
      } catch (error) {
        console.error("Failed to restore session:", error);
        localStorage.clear();
      } finally {
        setLoading(false);
      }
    };

    restoreSession();

    return () => {
      if (window.sessionTimeoutId) clearTimeout(window.sessionTimeoutId);
    };
  }, []);

  // 🔹 Login function - updates state and triggers a re-render
  const login = (token, role, userData) => {
    const loginTime = new Date().getTime();
    const sessionDuration = role === 'platformadmin' ? 30 * 60 * 1000 : 2 * 60 * 60 * 1000;
    setUser(userData);
    setToken(token);
    setRole(role);

    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', token);
    localStorage.setItem('role', role);
    localStorage.setItem('loginTime', loginTime);

    // Auto logout based on role
    if (window.sessionTimeoutId) clearTimeout(window.sessionTimeoutId);
    window.sessionTimeoutId = setTimeout(() => {
      logout();
    }, sessionDuration);
  };

  // 🔹 Logout function
  const logout = () => {
    setUser(null);
    setToken(null);
    setRole(null);
    localStorage.clear();
  };

  return (
    <UserContext.Provider value={{ user, token, role, login, logout, loading }}>
      {children}
    </UserContext.Provider>
  );
};
